(function () {
  "use strict";

  function slideStep(track, slide) {
    if (!track || !slide) {
      return 0;
    }

    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;

    return slide.getBoundingClientRect().width + gap;
  }

  function initRecipeSection(section) {
    if (!section || section.dataset.recipeSliderBound === "1") {
      return;
    }

    var track = section.querySelector("[data-recipe-track]");
    var slides = section.querySelectorAll("[data-recipe-slide]");
    var prevBtns = section.querySelectorAll("[data-recipe-prev]");
    var nextBtns = section.querySelectorAll("[data-recipe-next]");
    var pager = section.querySelector("[data-recipe-pager]");

    if (!track || !slides.length) {
      return;
    }

    var current = 0;
    var total = slides.length;
    var slider = section.querySelector("[data-recipe-slider]");

    function maxOffset() {
      var viewW = slider ? slider.clientWidth : 0;

      return Math.max(0, track.scrollWidth - viewW);
    }

    function maxIndex() {
      var step = slideStep(track, slides[0]);
      var overflow = maxOffset();

      if (step <= 0 || overflow <= 2) {
        return 0;
      }

      // 2px slack so subpixel leftover does not add an empty extra step.
      return Math.ceil((overflow - 2) / step);
    }

    function goTo(index) {
      var last = maxIndex();

      if (last === 0) {
        index = 0;
      } else if (index < 0) {
        index = last;
      } else if (index > last) {
        index = 0;
      }

      current = index;
      var x =
        current >= last && last > 0
          ? maxOffset()
          : current * slideStep(track, slides[0]);
      track.style.transform = "translateX(" + -x + "px)";

      if (pager) {
        pager.textContent = current + 1 + "/" + total;
      }
    }

    prevBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        goTo(current - 1);
      });
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        goTo(current + 1);
      });
    });

    var startX = 0;
    var endX = 0;

    track.addEventListener(
      "touchstart",
      function (event) {
        startX = event.changedTouches[0].screenX;
      },
      { passive: true }
    );

    track.addEventListener(
      "touchend",
      function (event) {
        endX = event.changedTouches[0].screenX;
        var diff = startX - endX;

        if (Math.abs(diff) > 50) {
          goTo(diff > 0 ? current + 1 : current - 1);
        }
      },
      { passive: true }
    );

    var resizeTimer;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        goTo(current);
      }, 200);
    });

    goTo(0);
    section.dataset.recipeSliderBound = "1";
  }

  function initRecipeSections() {
    document
      .querySelectorAll("[data-recipe-section]")
      .forEach(initRecipeSection);
  }

  window.initRecipeSections = initRecipeSections;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRecipeSections);
  } else {
    initRecipeSections();
  }
})();
